import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
import { environment } from '../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-referral',
    templateUrl: './referral.component.html',
    styleUrls: ['./referral.component.css']
})
export class ReferralComponent implements OnInit {

    constructor(
        public httpClient: HttpClient,
        private  route: ActivatedRoute,
    ){}
    agent_points = 0;
    agent_point2 = 0;
    agent_point_first = 0;
    agent_point = 0;
    relation = 0;
    earn_money = 0;
    agent_link_click = 0;
    agent_relation_item:any=[];
    time :any={};
    time2 :any={};
    time_info:any=-1;
    tool_obj:any={search_model:'',info:{},info_status:false,data_type:1,view:{}}
    search_model:string = '';
    sort_obj:any = {column:'create_dt',sort:'0'}
    top_info:any=[];
    data:any=[];
    link:string = environment.link;
    edit_data:any=[]
    code_history_data:any=[]
    link_data:any={once_diamond:0,can_assign_num:40,used_max_num:1,status:1,id:-1}
    father:any=[]
    loading:boolean=true;
    pageobj:page = {page:0,count:12,total_count:0};
    pageobj2:page = {page:0,count:8,total_count:0};
    pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
    pageobjstr2:string=JSON.parse(JSON.stringify(this.pageobj2))
    now:string = '1';
    subnow:string = '1';
    menu_list:menulist = [{id:'1',name:'代理列表'}];
    tcontent2 = [
        {title:'代理電話',content:'phone_num'},
        {title:'可提領金額',content:'can_withdrawal'},
        {title:'退款金額',content:'refund'},
        {title:'累積提領金額',content:'money'},
        {title:'下線數',content:'subnember',type:3},
        {title:'監察者的電話',content:'agphone_num'},
    ];

    tcontent3 = [
        {title:'掏妹大頭貼',content:'profile_pic',type:1},
        {title:'掏妹名',content:'uname'},
        {title:'加入日期',content:'create_dt'},
    ];
    
    timeset = [{ type:1 , name: "今天", num: -0 },{ type:3 , name: "昨天", num: -1 },{ type:1 , name: "過去7天", num: -7 },{ type:1 , name: "過去30天", num: -30 }, ,{ type:2 , name: "上個月", num: -1 }, { type:2 , name: "上上個月", num: -2 }];

    ranges: any = {
        '今天': [moment(), moment()],
        '昨天': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        '過去一周': [moment().subtract(6, 'days'), moment()],
        '過去30天': [moment().subtract(29, 'days'), moment()],
        '本月': [moment().startOf('month'), moment().endOf('month')],
        '過去一個月': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
    }

    isNumberKey(event: any) {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
          event.preventDefault();
        }
    }

    
    showDatePickered( value: any ): void {
        console.log(123);
        this.time.startDate =  '';
        this.time.endDate =  ''; 
        this.init_list();
    }


    handleRangeSelected( value: any ): void {
        
        let  eventDate = value.event;    
        
        if(eventDate.startDate){
            this.time.startDate =  moment(eventDate.startDate).format('YYYY-MM-DD')
            this.time.endDate =  moment(eventDate.endDate).format('YYYY-MM-DD')    
            this.init_list();

        }
    
    }

    ngOnInit(): void {
    
        if(this.route.snapshot.paramMap.get('id')){
            this.tool_obj.search_model = this.route.snapshot.paramMap.get('id');
        }
    
        this.init_time();
    }

    agent_point_update(id){

        let agText = '代理推薦首儲';
        let point = this.agent_points;

        if(id == 45){
            agText = '代理抽成';
            point = this.agent_point2;
        }

        Swal.fire({
            title: "確定"+agText+"修改為"+point+"?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "確定",
            cancelButtonText: "取消"
        }).then((result) => {
            if (result.isConfirmed) {
                
                this.loading = true;

                const body = {act:1,point:point,id:id,now:this.now,page: this.pageobj.page,count:this.pageobj.count,search:this.tool_obj.search_model,sort_obj:this.sort_obj,now_range:this.time};
                this.httpClient.post<any>("/get_referral_list.php",body).subscribe(res => {
                    
                    this.loading = false;
                
                    if(res.status){
                        Swal.fire("已更新完成!", "", "success");
                    }
                
                }, error => {
                  console.log(error);
                });
            }
        });
     
    }

    init_time(){
        // this.time.minDate = moment().subtract(180, 'days')
        // this.time.maxDate = moment().subtract(0, 'days')

        // let default_status = true;
        // if(this.time_info!=-1){
        //     const tmp = this.time_info.split("_");
        //     if(tmp.length==4){
        //         default_status = false;
        //         this.time.start = tmp[0]
        //         this.time.end = tmp[1]
                
                
        //         this.time.startDate = moment(tmp[0]);
        //         this.time.endDate = moment(tmp[1]);
            
        //     }
        // }
    
        // if(default_status){
        //     this.time.startDate = moment().subtract(7, 'days');
        //     this.time.endDate = moment().subtract(0, 'days');
        //     this.time.start = moment(this.time.startDate)
        //     this.time.end = moment(this.time.endDate)
        // }


        this.init_list();  
    }

    init_list(){
        this.loading = true;
        const body = {now:this.now,page: this.pageobj.page,count:this.pageobj.count,search:this.tool_obj.search_model,sort_obj:this.sort_obj,now_range:this.time};
        this.httpClient.post<any>("/get_referral_list.php",body).subscribe(res => {
            this.loading = false;
            this.top_info = res.top_info;
            if(res.status){
                this.data = res.data;
                this.relation = res.relation;
                this.earn_money = res.earn_money;
                this.agent_points = res.agent_points;
                this.agent_point2 = res.agent_point2;
                this.agent_link_click = res.agent_link_click;
                this.pageobj.total_count = res.total_count
            }else{
                this.pageobj.total_count = 0
                this.data = [];
            }
            console.log(res);
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
        }, error => {
          console.log(error);
        });
    }

    get_agent_relation(val){

        this.loading = true;
        const body = {page: this.pageobj2.page,count:this.pageobj2.count,item:val,now_range:this.time,act:2};
        this.httpClient.post<any>("/get_referral_list.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){

                this.agent_relation_item = res.data;
                this.pageobj2.total_count = res.total_count;
                this.pageobjstr2=JSON.parse(JSON.stringify(this.pageobj2))
            }

        }, error => {
          console.log(error);
        });

    }


    callback2(pageobj:page){
        if(JSON.stringify(this.pageobj2)!=JSON.stringify(pageobj)){
            this.pageobj2 = pageobj;
        }
    }

    defaultpage(){
        
        this.pageobj2 = {page:0,count:8,total_count:0};

    }

    callback(pageobj:page){
        if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
            this.pageobj = pageobj;
            this.init_list();
        }
    }

    choose(value:string){
        console.log('value',value);
        this.now = value;
        if(value=='1'){
            this.tool_obj.search_model = '';
            this.tool_obj.info = {};
            this.tool_obj.info_status = false;
            this.tool_obj.data_type = 1;
            this.init_list();
        }
    }


    onRangeSelected(type,value: any) {
        if(value.startDate){
            this.time.start =  moment(value.startDate).format('YYYY-MM-DD')
            this.time.end =  moment(value.endDate).format('YYYY-MM-DD')
            this.init_list();  
        }   
    }
}
